import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table, Badge } from 'antd';
import styles from './compare-schools-modal.module.scss';

/**
 * Modal component for comparing schools
 * @param {boolean} open - Whether the modal is visible
 * @param {function} onClose - Function to close the modal
 * @param {array} schools - Array of schools to compare
 */
export const CompareSchoolsModal = ({ open, onClose, schools = [] }) => {
  // const schoolsToCompare = schools?.length > 0 && schools;

  // const renderFeatureBadges = (features) => {
  //   return (
  //     <div className={styles.featureBadges}>
  //       {features.map((feature, index) => (
  //         <Badge
  //           key={index}
  //           className={styles.featureBadge}
  //           count={feature}
  //           style={{ backgroundColor: '#f3f4f6', color: '#374151' }}
  //         />
  //       ))}
  //     </div>
  //   );
  // };

  // const renderSpecialPrograms = (programs) => {
  //   return (
  //     <div className={styles.specialPrograms}>
  //       {programs.map((program, index) => (
  //         <div key={index} className={styles.program}>
  //           <div className={styles.programName}>{program.name}</div>
  //           <div className={styles.programDescription}>{program.description}</div>
  //         </div>
  //       ))}
  //     </div>
  //   );
  // };

  // const renderContacts = (contacts) => {
  //   return (
  //     <div className={styles.contacts}>
  //       {contacts.map((contact, index) => (
  //         <div key={index} className={styles.contact}>
  //           <div className={styles.contactName}>{contact.name}</div>
  //           <div className={styles.contactTitle}>{contact.title}</div>
  //           <div className={styles.contactEmail}>{contact.email}</div>
  //           {contact.phone && <div className={styles.contactPhone}>{contact.phone}</div>}
  //         </div>
  //       ))}
  //     </div>
  //   );
  // };

  return (
    <Modal
      title="Compare Schools"
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      className={styles.compareSchoolsModal}>
      <div className={styles.tableContainer}>
        <table className={styles.comparisonTable}>
          <thead>
            <tr>
              <th className={styles.featureColumn}>Feature</th>
              {schools?.map((school) => (
                <th key={school.school_id}>{school.school_name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Location</td>
              {schools?.map((school) => (
                <td key={school.school_id}>{school.address}</td>
              ))}
            </tr>
            {/* <tr>
              <td>Student-Teacher Ratio</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{school.studentTeacherRatio}</td>
              ))}
            </tr>
            <tr>
              <td>Overview</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{school.overview}</td>
              ))}
            </tr>
            <tr>
              <td>Grade Levels</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{school.gradeLevels}</td>
              ))}
            </tr>
            <tr>
              <td>Year Founded</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{school.yearFounded}</td>
              ))}
            </tr>
            <tr>
              <td>Key Features</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{renderFeatureBadges(school.keyFeatures)}</td>
              ))}
            </tr>
            <tr>
              <td>Special Programs</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{renderSpecialPrograms(school.specialPrograms)}</td>
              ))}
            </tr>
            <tr>
              <td>Key Contacts</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{renderContacts(school.keyContacts)}</td>
              ))}
            </tr>
            <tr>
              <td>First Day of School</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{school.firstDayOfSchool}</td>
              ))}
            </tr>
            <tr>
              <td>Transportation</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{school.transportation}</td>
              ))}
            </tr>
            <tr>
              <td>Student Resources</td>
              {schoolsToCompare.map((school) => (
                <td key={school.id}>{school.studentResources}</td>
              ))}
            </tr> */}
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

CompareSchoolsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  schools: PropTypes.array,
};

export default CompareSchoolsModal;
